import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './pills.module.scss';

const propTypes = {
  variant: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired
};

const Pill = ({variant = null, className = null, disabled = false, children}) => {
  const variantClass = variant !== null ? styles[`pill-${variant}`] : null;
  const disabledClass =
    variant !== null && disabled ? styles[`pill-${variant}--disabled`] : null;
  const pillClass = cx(className, styles.pill, variantClass, disabledClass);

  return <span className={pillClass}>{children}</span>;
};

Pill.propTypes = propTypes;

export default Pill;
